import {
    StrollerReviewsState,
    initialStrollerReviewsState,
} from "@/mk2/apps/strollers/containers/StrollerReviews/StrollerReviews.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollerReviewsState = (
    state: AppState,
    strollerSlug: string,
): StrollerReviewsState =>
    state.containers.strollers.strollersReviews[strollerSlug] || initialStrollerReviewsState;
